import React, { useContext, useState } from 'react';
import { Flex, Text, Box, IconButton, useDisclosure, Button, Icon } from '@chakra-ui/react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { MdClose, MdOutlineWarning } from 'react-icons/md';
import ProductLogo from '../../../products/components/productLogo';
import { ProductContext } from '../../../products/lib/productContext';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
export default function ProductInSharedExperienceListItem({ sharedExperienceId, onUpdate }) {
  const { product } = useContext(ProductContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const modalDelete = useDisclosure();
  const sharedExperiencesApi = useSharedExperiencesApi();
  async function removeProductFromSharedExperience() {
    try {
      setIsDeleting(true);
      await sharedExperiencesApi.unlinkProductFromSharedExperience(
        sharedExperienceId,
        product.id
      );
      setIsDeleting(false);
      modalDelete.onClose();
      if (onUpdate) {
        onUpdate();
      }
    } catch (e) {
      console.error(e);
      setIsDeleting(false);
    }
  }
  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        backgroundColor="white"
        role={'group'}
        flex={1}
        mb={1}
        px={3}
        h={"34px"}
        _hover={{
          backgroundColor: 'background.grey',
          borderRadius: '2px'
        }}
      >
        <Flex alignItems="center">
          <ProductLogo
            size={24}
            productId={product.id}
          />
          <Text ml={2}>{product.name}</Text>
        </Flex>
        <Box style={{ opacity: '0' }} _groupHover={{ opacity: '1 !important' }} >
          <IconButton
            icon={<MdClose />}
            size={'md'}
            variant='greyTransparent'
            onClick={(e) => {
              modalDelete.onOpen();
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        </Box>
      </Flex>
      <Modal isOpen={modalDelete.isOpen} onClose={modalDelete.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>Remove Product {product.name}</ModalHeader>
          <ModalBody p={3} >
            <Flex
              border="1px"
              borderColor="divider.grey"
              borderRadius="2px"
              backgroundColor="white"
              alignItems={'center'}
              p={3}
            >
              <Icon
                as={MdOutlineWarning}
                color={'text.medium.red'}
                boxSize={'18px'}
                mr={3}
              />
              <Text textStyle="body" color={'text.medium.red'} >
                Are you sure to remove the product {product.name} from this shared experiences?
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='redOutline'
              onClick={modalDelete.onClose}
            >Close</Button>
            <Button
              variant="redFill"
              ml={2}
              isLoading={isDeleting}
              onClick={removeProductFromSharedExperience}>Remove</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
} 